export default __webpack_public_path__ + "static/media/mobile-automation.6439bc18.svg";